import replaceValues from './replaceValues';
import replaceUrl from './replaceUrl';
import wueActionMap from './wueActionMap';

export default (result) => {
	let intention = result;
	let destinationUrl;

	if (typeof intention === 'string') {
		intention = replaceValues(intention, wueActionMap) || intention;
		const replacementObj = replaceUrl(intention);
		intention = replacementObj.updatedString;
		destinationUrl = replacementObj.destinationUrl;
	}

	return { intention, destinationUrl };
};
